import React from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import useClientPlants from "../../../../../../../hooks/useClientPlants";
import { POPageContextProvider } from "./POPageContext";
import PoMangerMain from "./Main";

export default function POPage() {
  const { plantId } = useParams();
  const { plants } = useClientPlants();
  const plant = plants.find((p) => String(p.id) === String(plantId)) || { id: plantId };

  return (
    <POPageContextProvider>
      <Box>
        <PageHeader plant={plant} pageTitle="Purchase Order (PO)" />
        <PoMangerMain />
      </Box>
    </POPageContextProvider>
  );
}
